import { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import { Outlet, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
// hooks
import useAuth from "../../hooks/useAuth";
//
// import TopHeader from "./TopHeader";
import Header from "./Header";
import Sidebar from "./Sidebar";
import MainNavbar from "../main/MainNavbar";
import { SubNavbar } from "../main/SubNavbar";
import useCategories from "../../hooks/useCategories";

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { user } = useAuth();
  const { headerCategories } = useCategories();
  let navigate = useNavigate();

  const [searchKeyword, setSearchKeyword] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const handleSearch = (e) => {
    const {name, value} = e.target;
    setSearchKeyword(value);
  };


  // useEffect(() => {
  //   if (searchParams.get("status") === "exitfromloanprocess") {
  //     window.history.pushState(null, null, window.location.pathname);
  //   }
  // }, [])
  const search = () => {
    if (searchKeyword !== null ) {
      navigate(`/mobiles?keyword=${searchKeyword}`);
      window.location.reload();
    }
  }
  return (
    <>
      {/* <TopHeader /> */}
      {/* <Header /> */}
      <MainNavbar
       renderSearchBar={true} 
       setSearchKeyword={setSearchKeyword}
       handleSearch={handleSearch}
      />
      <SubNavbar 
      categories={headerCategories}
      setSearchKeyword={setSearchKeyword}
      handleSearch={handleSearch}
      search={search}
      />
      <section id="vendor_area" className="ptb-50">
        <div className="container-fluid">
          <div className="row">
            <Sidebar />
            <div className="col-sm-12 col-md-12 col-lg-9">
              {/* {user?.onboarding === false && (
                <div className="alert alert-warning" role="alert">
                  On-boarding pending
                </div>
              )} */}
              <div className="vendor_dashboard">
                {/* <div className="tab-pane fade show active" id="dashboard"> */}
                <Outlet />
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
